/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppType } from "./AppType";
export const AppCreate = core.serialization.object({
    name: core.serialization.string(),
    namespace: core.serialization.string(),
    type: AppType,
    entity: core.serialization.string().optional(),
    entityPlural: core.serialization.string().optional(),
    icon: core.serialization.string().optional(),
    metadata: core.serialization.any().optional(),
    environmentFilters: core.serialization.any().optional(),
    blueprint: core.serialization.any().optional(),
});
